import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {t} from 'lib/I18n';

import Spinner from 'components/utils/Spinner';

export default class ChallengeButton extends React.Component {
  static propTypes = {
    contentService: PropTypes.object.isRequired,
    buttonState: PropTypes.object.isRequired,
    submitChallenge: PropTypes.func.isRequired,
    triggerQuiz: PropTypes.func.isRequired,
    isOrgSelected: PropTypes.bool.isRequired,
    authenticated: PropTypes.bool,
  }

  state = {
    inProgress: this.props.buttonState.inProgress,
    loggingIn: false,
    wasPressed: false,
  };

  UNSAFE_componentWillMount() {
    let btnText = t('views.react.superbadges.challenge_button.assessment');
    if (this.props.buttonState.isQuiz) {
      btnText = t('views.react.superbadges.challenge_button.quiz');
    }

    this.setState({
      btnText
    });
  }

  componentDidMount() {
    // this should be refactored to SuperbadgeUnits
    document.addEventListener('setActiveOrg', this.handleOrgSelection);
  }

  handleSubmitChallenge = () => {
    this.props.submitChallenge(this.props.buttonState.checkChallengePath);
  }

  handleLogInClick = () => {
    this.setState({
      loggingIn: true
    });

    document.dispatchEvent(new CustomEvent('trailhead_login'));
  }
  handleClick = () => {
    if (this.state.submitting) {
      return;
    }

    this.setState({
      inProgress: true,
      wasPressed: true
    });

    this.triggerStart();
  }

  triggerStart = () => {
    if (this.props.buttonState.isQuiz) {
      this.props.triggerQuiz();
    } else {
      this.handleSubmitChallenge();
    }
  }

  // Check if we need to override the enabled state when in preview mode
  previewModeOverride() {
    return this.props.contentService.inPreview &&
      (!this.state.wasPressed || (this.state.wasPressed && !this.props.buttonState.completed));
  }

  renderLogInButton() {
    const btnClass = classNames({
      'th-button--primary': !this.state.loggingIn,
      'th-button--neutral': this.state.loggingIn,
      'slds-button': true,
      'th-button': true,
      'th-button--medium': true
    });

    return (
      <div className="sb-challenge-btn slds-shrink-none slds-m-left_large">
        <button
          className={btnClass}
          onClick={this.handleLogInClick}
          disabled={this.state.loggingIn}
          data-test="sb-challenge-log-in-to-check"
        >
          {this.state.loggingIn &&
            <Spinner inline={true} className="slds-spinner_x-small" />
          }
          Log In to Take This Challenge
        </button>
      </div>
    );
  }
  renderEnabledOrSubmitting() {
    const btnClass = classNames({
      'th-button--primary': !this.props.buttonState.submitting,
      'th-button--neutral': this.props.buttonState.submitting,
      'slds-button': true,
      'th-button': true,
      'th-button--medium': true
    });

    return (
      <div className="sb-challenge-btn slds-shrink-none slds-m-left_large">
        <button
          className={btnClass}
          onClick={this.handleClick}
          disabled={this.props.buttonState.submitting}
          data-test="sb-challenge-check"
        >
          {this.props.buttonState.submitting &&
            <Spinner inline={true} className="slds-spinner_x-small" />
          }
          {this.state.btnText}
        </button>
      </div>
    );
  }

  render() {
    if (this.previewModeOverride()) {
      return this.renderEnabledOrSubmitting();
    }

    if (this.props.buttonState.completed) {
      return (
        <div className="sb-challenge-btn slds-shrink-none slds-m-left_large">
          <div className="sb-points-awarded">+{this.props.buttonState.points} points</div>
        </div>
      );
    } else if (!this.props.authenticated && this.props.buttonState.index === 0) {
      return this.renderLogInButton();
    } else if (this.props.buttonState.enabled && this.props.isOrgSelected) {
      return this.renderEnabledOrSubmitting();
    }

    return (
      <div className="sb-challenge-btn slds-shrink-none slds-m-left_large">
        <button className="slds-button th-button th-button--medium th-button--neutral" disabled>
          {this.state.btnText}
        </button>
      </div>
    );
  }
}
